var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 6,
    fill: "#D9D8F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 7.35352L12.5 11.291L19.0625 7.35352M7.25 16.8263C6.2835 16.8263 5.5 16.0428 5.5 15.0763V8.22852C5.5 7.26202 6.2835 6.47852 7.25 6.47852H17.75C18.7165 6.47852 19.5 7.26202 19.5 8.22852V15.0763C19.5 16.0428 18.7165 16.8263 17.75 16.8263H7.25Z",
    stroke: "#6940F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoMail);
export default __webpack_public_path__ + "static/media/info-mail.7e2c2fd944b52a77f900fb413ce959f3.svg";
export { ForwardRef as ReactComponent };